<template lang="pug">
  section.article
    //- ArticleHeader(:img="article.img", :title="article.title", :undertitle="article.undertitle", :beforetitle="article.beforetitle",
    //- :aftertitle="article.aftertitle",
    //- :alignment="article.alignment")
    ArticleHeader(:firstname="article.firstname", :lastname="article.lastname", :rudo="article.video", :image="article.slug", :age="article.age", :city="article.city", :prize="article.prize", :capital="article.capital", :employees="article.employees", :lesson="article.lesson")

    .description
      .logo-description
        h2.title
          small.firstname {{article.firstname}}
          span.lastname {{article.lastname}}
      .wrap-description
        h4 {{article.prizetitle}}
        Sharer.sharerwrap(
        :baseurl="config.baseurl", :slug="$route.path", :title="article.share.title", :description="article.share.description", :img="config.img",:hashtag="config.hashtag", :brandtitle="config.brandtitle", :reporttitle="config.reporttitle")
        p.prize
          strong Tipo de emprendimiento y  premio obtenido:
          span  {{article.prize}}
        p.capital
          strong Capital inicial y año de comienzo del emprendimiento:
          span  {{article.capital}}
        p.employees
          strong Número de empleados:
          span  {{article.employees}}
        p.lesson
          strong Lección Emprendedora:
          span  {{article.lesson}}
</template>
<script>
import { mapState } from 'vuex'
import ArticleHeader from '@/components/BancoEstado/ArticleHeader'
import Sharer from '@/components/Sharer'

export default {
  components: {
    ArticleHeader,
    Sharer,
  },
  computed: {
    ...mapState([
      'config'
    ]),
    article(){
      const article = this.$store.getters.getArticle(this.$route.params.article)
      return article
    },
  },
  metaInfo() {
    return {
      title: 'Valientes Bancoestado - Especiales La Tercera',
      titleTemplate: this.article.share.title + ' - %s',
      meta: [
        {
          vmid: 'ogtitle',
          property: 'og:title',
          content: `${this.article.share.title} - ${this.config.reporttitle} - ${this.config.brandtitle}`
        },
        {
          vmid: 'ogdescription',
          property: 'og:description',
          content: this.article.share.description,
        },
        {
          vmid: 'ogurl',
          property: 'og:url',
          content: this.config.baseurl + this.$route.path
        },
        {
          vmid: 'ogimage',
          property: 'og:image',
          content: this.config.baseurl + '/' + this.article.share.img
        },
        {
          vmid: 'ogsecureimage',
          property: 'og:secure:image',
          content: this.config.baseurl + '/' + this.article.share.img
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
  .sharerwrap{
    margin-bottom: 1rem;
    /deep/ a {
      color: white;
      border-color: white;
    }
  }
  h2{
    text-align: center;
  }
  .lastname{
    display: block;
    transform: skewY(-8deg);
    font-size: 4rem;
  }
  .firstname{
    font-family: 'Open Sans', sans-serif;
    font-weight: bold;
    text-transform: uppercase;
    font-size: 1.5rem;
    padding-bottom: 2rem;
    display: block;
  }
  .wrap-description{
    max-width: $maxwidth;
    margin-left: auto;
    margin-right: auto;
    h4{
      text-align: center;
    }
  }
  .description{
    margin-left: auto;
    margin-right: auto;
    font-size: 1rem;
    text-indent: 0;
    text-align: left;
    width: 100%;
    background-color: #797979;
    border-top: 1.5rem solid #ff6804;
    padding: 1rem 2rem;
    align-items: center;
    justify-content: center;
    transition: all .3s;
    flex-direction: column;
    color: white;
    span{
      display: block;
    }
    p{
      font-size: 0.8rem;
      line-height: 120%;
      padding-bottom: 0.5rem;
      text-indent: 0;
    }
  }
  h4{
    font-size: 2rem;
    padding: 0.5rem 0;
    font-style: italic;
  }
</style>

